import {
  Button,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  List,
  ListItem,
  ListItemText,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel
} from '@mui/material'
import moment from 'moment'
import { useEffect, useState } from 'react'

import { useStatistics } from '../Contexts/StatisticsContext'

const SingleOrganizationTable = ({ filters }) => {
  const { useFetchRootOrganizationStatistics } = useStatistics()
  const [stats, setStats] = useState([])
  const [sortOrder, setSortOrder] = useState('asc')
  const [openDialog, setOpenDialog] = useState(false)
  const [selectedDetails, setSelectedDetails] = useState([])

  // Centralized styles
  const styles = {
    totalsRow: {
      backgroundColor: 'rgba(0, 0, 0, 0.1)',
      fontWeight: 'bold',
      height: '32px'
    },
    totalsCellBase: {
      fontSize: '0.75rem',
      padding: '4px 8px'
    },
    totalsCellBold: {
      fontSize: '0.75rem',
      padding: '4px 8px',
      fontWeight: 'bold'
    }
  }

  useEffect(() => {
    useFetchRootOrganizationStatistics({ payload: filters })
      .then((res) => {
        setStats(res.data)
      })
  }, [filters])

  const handleDeviceClick = (details) => {
    setSelectedDetails(details)
    setOpenDialog(true)
  }

  // Calculate totals for numeric columns
  const calculateTotals = () => {
    return stats.reduce((totals, row) => ({
      totalDevicesCount: totals.totalDevicesCount + (row.data.totalDevicesCount || 0),
      apiCall: totals.apiCall + (row.data.apiCall || 0),
      organizationsCreation: totals.organizationsCreation + (row.data.organizationsCreation || 0),
      measuresCount: totals.measuresCount + (row.data.measuresCount || 0),
      totalMeasures: totals.totalMeasures + (row.organization?.isRoot ? (row.data.totalMeasures || 0) : 0),
      totalEventsAlarm: totals.totalEventsAlarm + (row.organization?.isRoot ? (row.data.totalEventsAlarm || 0) : 0),
      eventsAlarm: totals.eventsAlarm + (row.data.eventsAlarm || 0),
      totalEventsCommunication: totals.totalEventsCommunication + (row.organization?.isRoot ? (row.data.totalEventsCommunication || 0) : 0),
      eventsCommunication: totals.eventsCommunication + (row.data.eventsCommunication || 0),
      totalEventsDelta: totals.totalEventsDelta + (row.organization?.isRoot ? (row.data.totalEventsDelta || 0) : 0),
      eventsDelta: totals.eventsDelta + (row.data.eventsDelta || 0),
      totalEventsActivation: totals.totalEventsActivation + (row.organization?.isRoot ? (row.data.totalEventsActivation || 0) : 0),
      eventsActivation: totals.eventsActivation + (row.data.eventsActivation || 0),
      totalEventsThreshold: totals.totalEventsThreshold + (row.organization?.isRoot ? (row.data.totalEventsThreshold || 0) : 0),
      eventsThreshold: totals.eventsThreshold + (row.data.eventsThreshold || 0),
      totalEventsScheduledTrigger: totals.totalEventsScheduledTrigger + (row.organization?.isRoot ? (row.data.totalEventsScheduledTrigger || 0) : 0),
      eventsScheduledTrigger: totals.eventsScheduledTrigger + (row.data.eventsScheduledTrigger || 0),
      totalEventsMeasureTrigger: totals.totalEventsMeasureTrigger + (row.organization?.isRoot ? (row.data.totalEventsMeasureTrigger || 0) : 0),
      eventsMeasureTrigger: totals.eventsMeasureTrigger + (row.data.eventsMeasureTrigger || 0),
      totalEventsMeasureCommunication: totals.totalEventsMeasureCommunication + (row.organization?.isRoot ? (row.data.totalEventsMeasureCommunication || 0) : 0),
      eventsMeasureCommunication: totals.eventsMeasureCommunication + (row.data.eventsMeasureCommunication || 0)
    }), {
      totalDevicesCount: 0,
      apiCall: 0,
      organizationsCreation: 0,
      measuresCount: 0,
      totalMeasures: 0,
      totalEventsAlarm: 0,
      eventsAlarm: 0,
      totalEventsCommunication: 0,
      eventsCommunication: 0,
      totalEventsDelta: 0,
      eventsDelta: 0,
      totalEventsActivation: 0,
      eventsActivation: 0,
      totalEventsThreshold: 0,
      eventsThreshold: 0,
      totalEventsScheduledTrigger: 0,
      eventsScheduledTrigger: 0,
      totalEventsMeasureTrigger: 0,
      eventsMeasureTrigger: 0,
      totalEventsMeasureCommunication: 0,
      eventsMeasureCommunication: 0
    })
  }

  const totals = calculateTotals()

  return (
    <>
      <Container
        maxWidth="lg"
        sx={{ py: 3 }}>
        <TableContainer component={Paper}>
          <Table stickyHeader sx={{ minWidth: 650 }} aria-label="statistics single table" data-testid="statistics-single-table">
            <TableHead>
              <TableRow>
                <TableCell>
                  <TableSortLabel

                    direction={sortOrder === 'asc' ? 'desc' : 'asc'}
                    onClick={() => setSortOrder(prev => prev === 'asc' ? 'desc' : 'asc')} sx={{
                      cursor: 'pointer',
                      '&:hover': {
                        textDecoration: 'underline'
                      },
                      '&.Mui-focusVisible': {
                        textDecoration: 'underline'
                      }
                    }}
                  >
                    Organizzazione
                  </TableSortLabel>
                </TableCell>
                <TableCell align="right">Ultimo aggiornamento</TableCell>
                <TableCell align="right">Devices</TableCell>
                <TableCell align="right">Soglia Devices</TableCell>
                <TableCell align="right">Api Calls</TableCell>
                <TableCell align="right">Soglia Api Calls</TableCell>
                <TableCell align="right">Organizations</TableCell>
                <TableCell align="right">Soglia Organizations</TableCell>
                <TableCell align="right">Misure Org Root</TableCell>
                <TableCell align="right">Totale Misure con figlie</TableCell>
                <TableCell align="right">Totale Eventi Allarme</TableCell>
                <TableCell align="right">Eventi Allarme</TableCell>
                <TableCell align="right">Totale Eventi Comunicazione</TableCell>
                <TableCell align="right">Eventi Comunicazione</TableCell>
                <TableCell align="right">Totale Eventi Delta</TableCell>
                <TableCell align="right">Eventi Delta</TableCell>
                <TableCell align="right">Totale Eventi Activation</TableCell>
                <TableCell align="right">Eventi Activation</TableCell>
                <TableCell align="right">Totale Eventi Threshold</TableCell>
                <TableCell align="right">Eventi Threshold</TableCell>
                <TableCell align="right">Totale Eventi Schedulati</TableCell>
                <TableCell align="right">Eventi Schedulati</TableCell>
                <TableCell align="right">Totale Eventi Trigger Misura</TableCell>
                <TableCell align="right">Eventi Trigger Misura</TableCell>
                <TableCell align="right">Totale Eventi Comunicazione Misura</TableCell>
                <TableCell align="right">Eventi Comunicazione Misura</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {[...stats]
                .sort((a, b) =>
                  sortOrder === 'asc'
                    ? a.organizationKey.localeCompare(b.organizationKey)
                    : b.organizationKey.localeCompare(a.organizationKey)
                )
                .map((row, index) => (
                  <TableRow
                    key={`${row.organizationKey}-${index}`}
                    sx={{
                      '&:last-child td, &:last-child th': { border: 0 },
                      backgroundColor: row.organization?.isRoot ? 'rgba(0, 123, 255, 0.1)' : undefined
                    }}
                  >
                    <TableCell component="th" scope="row">
                      {row.organizationKey}
                    </TableCell>
                    <TableCell align="right">{moment(row.timestamp).format('YYYY-MM-DD')}</TableCell>
                    <TableCell align="right" sx={{ cursor: 'pointer' }} onClick={() => row.data.brandsModels && handleDeviceClick(row.data.brandsModels)}>
                      {row.data.totalDevicesCount || 0}
                    </TableCell>
                    <TableCell align="right">{row.organization?.profile?.maxDevicesCount}</TableCell>
                    <TableCell align="right">{row.data.apiCall || 0}</TableCell>
                    <TableCell align="right">{row.organization?.profile?.maxCallsPerMonthCount}</TableCell>
                    <TableCell align="right">{row.data.organizationsCreation || 0}</TableCell>
                    <TableCell align="right">{row.organization?.profile?.maxOrganizationsCount}</TableCell>
                    <TableCell align="right">{row.data.measuresCount || 0}</TableCell>
                    <TableCell align="right">{row.organization?.isRoot ? row.data.totalMeasures || 0 : ''}</TableCell>
                    <TableCell align="right">{row.organization?.isRoot ? row.data.totalEventsAlarm || 0 : ''}</TableCell>
                    <TableCell align="right">{row.data.eventsAlarm || 0}</TableCell>
                    <TableCell align="right">{row.organization?.isRoot ? row.data.totalEventsCommunication || 0 : ''}</TableCell>
                    <TableCell align="right">{row.data.eventsCommunication || 0}</TableCell>
                    <TableCell align="right">{row.organization?.isRoot ? row.data.totalEventsDelta || 0 : ''}</TableCell>
                    <TableCell align="right">{row.data.eventsDelta || 0}</TableCell>
                    <TableCell align="right">{row.organization?.isRoot ? row.data.totalEventsActivation || 0 : ''}</TableCell>
                    <TableCell align="right">{row.data.eventsActivation || 0}</TableCell>
                    <TableCell align="right">{row.organization?.isRoot ? row.data.totalEventsThreshold || 0 : ''}</TableCell>
                    <TableCell align="right">{row.data.eventsThreshold || 0}</TableCell>
                    <TableCell align="right">{row.organization?.isRoot ? row.data.totalEventsScheduledTrigger || 0 : ''}</TableCell>
                    <TableCell align="right">{row.data.eventsScheduledTrigger || 0}</TableCell>
                    <TableCell align="right">{row.organization?.isRoot ? row.data.totalEventsMeasureTrigger || 0 : ''}</TableCell>
                    <TableCell align="right">{row.data.eventsMeasureTrigger || 0}</TableCell>
                    <TableCell align="right">{row.organization?.isRoot ? row.data.totalEventsMeasureCommunication || 0 : ''}</TableCell>
                    <TableCell align="right">{row.data.eventsMeasureCommunication || 0}</TableCell>
                  </TableRow>
                ))}
              {/* Totals Row */}
              <TableRow sx={styles.totalsRow}>
                <TableCell component="th" scope="row" sx={styles.totalsCellBold}>
                  TOTALI
                </TableCell>
                <TableCell align="right" sx={styles.totalsCellBase}>-</TableCell>
                <TableCell align="right" sx={styles.totalsCellBold}>{totals.totalDevicesCount}</TableCell>
                <TableCell align="right" sx={styles.totalsCellBase}>-</TableCell>
                <TableCell align="right" sx={styles.totalsCellBold}>{totals.apiCall}</TableCell>
                <TableCell align="right" sx={styles.totalsCellBase}>-</TableCell>
                <TableCell align="right" sx={styles.totalsCellBold}>{totals.organizationsCreation}</TableCell>
                <TableCell align="right" sx={styles.totalsCellBase}>-</TableCell>
                <TableCell align="right" sx={styles.totalsCellBold}>{totals.measuresCount}</TableCell>
                <TableCell align="right" sx={styles.totalsCellBold}>{totals.totalMeasures}</TableCell>
                <TableCell align="right" sx={styles.totalsCellBold}>{totals.totalEventsAlarm}</TableCell>
                <TableCell align="right" sx={styles.totalsCellBold}>{totals.eventsAlarm}</TableCell>
                <TableCell align="right" sx={styles.totalsCellBold}>{totals.totalEventsCommunication}</TableCell>
                <TableCell align="right" sx={styles.totalsCellBold}>{totals.eventsCommunication}</TableCell>
                <TableCell align="right" sx={styles.totalsCellBold}>{totals.totalEventsDelta}</TableCell>
                <TableCell align="right" sx={styles.totalsCellBold}>{totals.eventsDelta}</TableCell>
                <TableCell align="right" sx={styles.totalsCellBold}>{totals.totalEventsActivation}</TableCell>
                <TableCell align="right" sx={styles.totalsCellBold}>{totals.eventsActivation}</TableCell>
                <TableCell align="right" sx={styles.totalsCellBold}>{totals.totalEventsThreshold}</TableCell>
                <TableCell align="right" sx={styles.totalsCellBold}>{totals.eventsThreshold}</TableCell>
                <TableCell align="right" sx={styles.totalsCellBold}>{totals.totalEventsScheduledTrigger}</TableCell>
                <TableCell align="right" sx={styles.totalsCellBold}>{totals.eventsScheduledTrigger}</TableCell>
                <TableCell align="right" sx={styles.totalsCellBold}>{totals.totalEventsMeasureTrigger}</TableCell>
                <TableCell align="right" sx={styles.totalsCellBold}>{totals.eventsMeasureTrigger}</TableCell>
                <TableCell align="right" sx={styles.totalsCellBold}>{totals.totalEventsMeasureCommunication}</TableCell>
                <TableCell align="right" sx={styles.totalsCellBold}>{totals.eventsMeasureCommunication}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Container>
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Dettaglio dispositivi per marca/modello</DialogTitle>
        <DialogContent>
          <List>
            {selectedDetails.map((item, index) => (
              <ListItem key={index}>
                <ListItemText primary={`${item.brandModelEncoded}`} secondary={`Conteggio: ${item.count}`} />
              </ListItem>
            ))}
          </List>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)}>Chiudi</Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default SingleOrganizationTable
